import { gql } from '@apollo/client';
const TOURNAMENT_DRAWS_CATEGORIES = gql`
  query tournamentDrawCategories($filter: ListDrawInput) {
    tournamentDrawCategories(filter: $filter)
  }
`;
export default TOURNAMENT_DRAWS_CATEGORIES;
